import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { BASE_URL } from "../config";

const VerifyAccountModal = ({
  isOpen,
  onClose,
  accountId,
  firstName,
  lastName,
  email,
  onVerified,
}) => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [loading, setLoading] = useState(false);

  

  if (!isOpen) return null;


 
const verifyPasswordAndNext = async () => {
  try {
    setLoading(true);
    setPasswordError("");
    const trimmedPassword = password.trim();
    const token =
      sessionStorage.getItem("token") || localStorage.getItem("token");

    if (!trimmedPassword) {
      setPasswordError("Password required."); 
      return;
    }

    const res = await fetch(
      `${BASE_URL}/api/admin/accounts/verify-password`,
      {
        method: "POST",
        credentials: "include", // ✅ THIS is what your app uses
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({
          password: trimmedPassword,
          accountId,
        }),
      }
    );

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      setPasswordError(data.message || "Verification failed.");
      return;
    }

    if (!data.success) {
      setPasswordError(data.message || "Invalid password.");
      return;
    }

    setPassword("");
    onVerified();

  } catch (err) {
    console.error("Verify password error:", err);
    setPasswordError("Something went wrong.");
  } finally {
    setLoading(false);
  }
};



  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-3 sm:p-4">
      <div className="bg-white w-full max-w-[420px] rounded shadow-lg p-4 sm:p-6">
        <h2 className="text-lg font-semibold mb-2">Verify your account</h2>

        <p className="text-sm text-gray-500 mb-5">
          To continue, first verify it’s you
        </p>

        <div className="mb-3 text-center font-medium">
          {firstName} {lastName}
          {email ? (
            <div className="text-sm font-normal text-gray-500">{email}</div>
          ) : null}
        </div>

        <div className="relative mb-2">
          {/* Keep browser autofill scoped to this modal, so it doesn't fill page search inputs */}
          <input
            type="text"
            name="username"
            autoComplete="username"
            defaultValue={email || ""}
            tabIndex={-1}
            className="absolute -left-[9999px] w-px h-px opacity-0 pointer-events-none"
            readOnly
          />

          <input
            type={showPassword ? "text" : "password"}
            placeholder="Enter your password"
            name="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            onKeyDown={(e) => {
              if (e.key === "Enter" && !loading) {
                verifyPasswordAndNext();
              }
            }}
            className="w-full border rounded px-3 py-2 pr-10"
          />

          <span
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-gray-500"
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>

        {passwordError && (
          <p className="text-red-500 text-sm mt-1">{passwordError}</p>
        )}

        <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-2 sm:gap-4 mt-5">
          <button
            onClick={() => {
              setPassword("");
              setPasswordError("");
              onClose();
            }}
            className="w-full sm:w-auto text-gray-600"
          >
            CANCEL
          </button>

          <button
            onClick={verifyPasswordAndNext}
            disabled={loading || !password.trim()}
            className="w-full sm:w-auto text-red-600 font-semibold disabled:opacity-50"
          >
            NEXT
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerifyAccountModal;
